import React, { useEffect, useState } from 'react';
import '../styles/background.css';
import AboutHero from '../components/Company/AboutHero';
import CertGrid from '../components/Company/CertGrid'; 
import ContactSection from '../components/Company/ContactSection';
import Footer from '../components/layout/footer';



    export default function CompanyInfo() {
    const [loading, setLoading] = useState(true);
  
    useEffect(() => {
      window.scrollTo(0, 0);
  
      // Function to prevent right-click
      const handleContextMenu = (e) => {
        e.preventDefault();
      };
  
      // Add listener when component mounts
      document.addEventListener("contextmenu", handleContextMenu);
  
      const timer = setTimeout(() => setLoading(false), 500);
  
      // Clean up listener when component unmounts
      return () => {
        document.removeEventListener("contextmenu", handleContextMenu);
        clearTimeout(timer);
      };
    }, []);

  return (
      <div className="tech-bg min-h-screen w-full"> 
       <div className="relative z-10">
        <section id="about-section" className="scroll-mt-20">
          <AboutHero />
        </section>
        
        <section id="cert-section" className="scroll-mt-20">
          <CertGrid />
        </section>
        
        <section id="contact-section" className="scroll-mt-20">
          <ContactSection />
        </section>

        <section id="Footer">
            <Footer />
        </section>
           
          </div>
       </div>
      


  );
}